import * as qs from 'qs';
import * as queryString from 'query-string';
import React, { Component, FormEvent } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios, { AxiosRequestConfig } from 'axios';
import { Panel, Button, FormControl, Alert, FormGroup, Form, ControlLabel, Modal, Col } from 'react-bootstrap';
import PasswordField from './password-field';
import { IForgotPasswordResponse, IForgotUsernameResponse } from '@nkr/models/index';

interface IOwnProps extends RouteComponentProps<{}> {
    onShowLoading: () => void
    onHideLoading: () => void,
    onReturn: () => void
};

type TProps = IOwnProps;

interface IState {
    [index: string]: string | boolean,
    forgotPassword: boolean,
    forgotUsername: boolean,
    passwordReset: boolean,
    username: string,
    email: string,
    newPassword: string,
    newPasswordConfirm: string,
    message: string,
    alert: boolean,
    success: boolean,
    showModal: boolean,
    modalMessage: string
};

const initialState: IState = {
    forgotPassword: true,
    forgotUsername: false,
    passwordReset: false,
    username: '',
    email: '',
    newPassword: '',
    newPasswordConfirm: '',
    message: '',
    alert: false,
    success: false,
    showModal: false,
    modalMessage: ''
};

const postConfig: AxiosRequestConfig = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    withCredentials: true
};

class ForgotCredentials extends Component<TProps, IState> {
    readonly state: IState = initialState;

    componentDidMount = () => {
        let parsed = queryString.parse(this.props.location.search);

        let { token, username } = parsed;

        if (token && username) {
            this.setState({
                passwordReset: true,
                forgotPassword: false,
                forgotUsername: false
            })

            this.props.onShowLoading();

            let body = {
                token,
                username
            }

            let url = __API__ + '/password-reset-token';

            axios.post(url, qs.stringify(body), postConfig)
                .then((res: IForgotPasswordResponse) => {
                    let { success, message } = res.data

                    this.props.onHideLoading();

                    if (success) {
                        this.setState({
                            passwordReset: true,
                            forgotPassword: false,
                            forgotUsername: false,
                            message: '',
                            alert: false,
                            success: false
                        })
                    }

                    if (!success) {
                        this.setState({
                            passwordReset: true,
                            forgotPassword: false,
                            forgotUsername: false,
                            message,
                            alert: true,
                            success: false
                        })
                    }
                })
                .catch((error: any) => {
                    this.setState({
                        passwordReset: true,
                        forgotPassword: false,
                        forgotUsername: false,
                        message: 'There was an error trying to access this link',
                        success: false,
                        alert: true
                    }, () => {
                        this.props.onHideLoading();
                    })
                });
        }
    }

    handleTextInputChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        // let name = e.currentTarget.name;
        // let value = e.currentTarget.value;
        let { name, value } = e.currentTarget;

        this.setState({
            [name]: value
        });
    }

    handlePasswordChange = (name: string, value: string) => {
        this.setState({
            [name]: value
        });
    }

    handleResetPassword = (e: FormEvent<Form>) => {
        e.preventDefault();
        this.props.onShowLoading();

        let { username } = this.state;

        let body = {
            username
        }

        let url = __API__ + '/forgot-password';

        axios.post(url, qs.stringify(body), postConfig)
            .then((res: IForgotPasswordResponse) => {
                let { success, message } = res.data

                this.props.onHideLoading();

                if (success) {
                    this.setState({
                        showModal: true,
                        modalMessage: message
                    })
                }
            })
            .catch((error: any) => {
                this.setState({
                    message: 'There was a network error trying to reset password',
                    success: false,
                    alert: true
                }, () => {
                    this.props.onHideLoading();
                })
            });
    }

    handleForgotUsername = (e: FormEvent<Form>) => {
        e.preventDefault();
        this.props.onShowLoading();

        let { email } = this.state;

        let url = __API__ + '/forgot-username';

        let body = {
            email
        }

        axios.post(url, qs.stringify(body), postConfig)
            .then((res: IForgotUsernameResponse) => {
                let { success, message } = res.data

                this.props.onHideLoading();

                if (success) {
                    this.setState({
                        showModal: true,
                        modalMessage: message
                    })
                }
            })
            .catch((error: any) => {
                this.setState({
                    message: 'There was a network error trying to retrieve username(s)',
                    success: false,
                    alert: true
                }, () => {
                    this.props.onHideLoading();
                })
            });
    }

    handleUpdatePasswordWithToken = (e: FormEvent<Form>) => {
        e.preventDefault();

        let regex = new RegExp('^(?=.*[A-Z])(?=.*[^\w])(?=.*[0-9])(?=.*[a-z]).{8,}$')
        let parsed = queryString.parse(this.props.location.search);
        let { token, username } = parsed;
        let { newPassword, newPasswordConfirm } = this.state;

        if (!newPassword || !newPasswordConfirm) {
            return this.setState({
                message: 'Field(s) cannot be blank',
                alert: true
            })
        }

        if (newPassword != newPasswordConfirm) {
            return this.setState({
                message: 'Passwords do not match',
                alert: true
            })
        }

        if (!regex.test(newPassword)) {
            return this.setState({
                message: 'New password must contain lower, upper, numeric, and symbol (min length=8)',
                alert: true
            })
        }

        this.setState({
            message: '',
            alert: false,
            success: false
        })

        this.props.onShowLoading();

        let url = __API__ + '/update-forgotten-password';

        let body = {
            token,
            username,
            new_password: newPassword,
            new_password_confirm: newPasswordConfirm
        }

        axios.post(url, qs.stringify(body), postConfig)
            .then((res: IForgotPasswordResponse) => {
                let { success, message } = res.data

                this.props.onHideLoading();

                if (success) {
                    this.setState({
                        passwordReset: true,
                        forgotPassword: false,
                        forgotUsername: false,
                        message,
                        success: true,
                        alert: false
                    }, () => {
                        this.handleGoToLogin()
                    })
                }

                if (!success) {
                    this.setState({
                        passwordReset: true,
                        forgotPassword: false,
                        forgotUsername: false,
                        message,
                        alert: true,
                        success: false
                    })
                }
            })
            .catch((error: any) => {
                this.setState({
                    message: 'There was a network error trying to update your new password',
                    success: false,
                    alert: true
                }, () => {
                    this.props.onHideLoading();
                })
            });
    }

    handleReturn = () => {
        this.setState({
            forgotPassword: true,
            forgotUsername: false,
            passwordReset: false,
            message: '',
            alert: false,
            success: false
        })

        this.props.onReturn()
    }

    handleGoToLogin = () => {
        this.wipeMessages()
        this.props.onReturn()
        this.props.history.push('/login?next=/')
    }

    wipeMessages = () => {
        this.setState({
            message: '',
            alert: false,
            success: false
        })
    }

    switchForm = () => {
        this.setState(prevState => ({
            forgotPassword: !prevState.forgotPassword,
            forgotUsername: !prevState.forgotUsername
        }));
    }

    handleModalClose = () => {
        this.setState({
            showModal: false,
            modalMessage: '',
        }, () => {
            this.handleReturn();
        })
    }

    render = () => {
        let { message, forgotPassword, forgotUsername, passwordReset, username, email, newPassword, newPasswordConfirm, alert, success, showModal, modalMessage } = this.state;

        return (
            <>
                {forgotPassword &&
                    <Form horizontal onSubmit={this.handleResetPassword} action='#' method='post'>
                        <div className='theme-content'>
                            <div className='theme-content-title'>Forgot Password?</div>

                            {alert &&
                                <Alert bsStyle={'danger'}>
                                    {message}
                                </Alert>
                            }
                            <Alert bsStyle='info'>
                                Because your password is encrypted using a one-way encryption for the ultimate protection, we are unable to
                                retrieve your password for you. However, by entering your username below, we will send an e-mail to you allowing
                                you to change your password.
                            </Alert>

                            <FormGroup bsSize='lg'>
                                <Col xs={12} lg={2} componentClass={ControlLabel}>Username</Col>
                                <Col xs={12} lg={9}>
                                    <FormControl
                                        name='username'
                                        value={username}
                                        onChange={this.handleTextInputChange}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup>
                                <Col xs={12} lg={2} componentClass={ControlLabel}></Col>
                                <Col xs={12} lg={2}>
                                    <Button bsSize='lg' type='submit'>Send</Button>
                                </Col>
                                <Col xs={12} lg={7} style={{ textAlign: 'right' }}>
                                    <Button bsStyle='link' bsSize='lg' onClick={this.switchForm}>Forgot Username?</Button>
                                    <Button bsStyle='link' bsSize='lg' onClick={this.handleReturn}> Back to Login Page </Button>
                                </Col>
                            </FormGroup>
                        </div>
                    </Form>
                }

                {forgotUsername &&
                    <Form horizontal onSubmit={this.handleForgotUsername} action='#' method='post'>
                        <div className='theme-content'>
                            <div className='theme-content-title'>Forgot Username?</div>

                            {alert &&
                                <Alert bsStyle={'danger'}>
                                    {message}
                                </Alert>
                            }
                            <Alert bsStyle='info'>
                                If you have forgotten your username, please enter your e-mail address below.  Any username associated with
                                that e-mail address will then be sent to your e-mail.
                            </Alert>

                            <FormGroup bsSize='lg'>
                                <Col xs={12} lg={3} componentClass={ControlLabel}>Email Address</Col>
                                <Col xs={12} lg={9}>
                                    <FormControl
                                    name='email'
                                    value={email}
                                    onChange={this.handleTextInputChange}
                                />
                                </Col>
                            </FormGroup>

                            <FormGroup>
                                <Col xs={12} lg={3} componentClass={ControlLabel}></Col>
                                <Col xs={12} lg={1}>
                                    <Button bsSize='lg' type='submit'>Send</Button>
                                </Col>
                                <Col xs={12} lg={8} style={{ textAlign: 'right' }}>
                                    <Button bsStyle='link' bsSize='lg' onClick={this.switchForm}> Back to Forgot Password </Button>
                                    <Button bsStyle='link' bsSize='lg' onClick={this.handleReturn}> Back to Login Page </Button>
                                </Col>
                            </FormGroup>
                        </div>
                    </Form>
                }

                {passwordReset &&
                    <Form onSubmit={this.handleUpdatePasswordWithToken} action='#' method='post'>
                        {(alert || success) &&
                            <Alert bsStyle={alert ? 'danger' : 'success'}>
                                {message}
                            </Alert>
                        }
                        <Alert bsStyle='info'>
                            Your password should include upper and lower case letters, numbers, and symbols, with a minimum length of 8 characters.
                        </Alert>
                        <FormGroup >
                            <ControlLabel>New Password</ControlLabel>
                            <PasswordField
                                name='newPassword'
                                value={newPassword}
                                onChange={this.handlePasswordChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Confirm New Password</ControlLabel>
                            <PasswordField
                                name='newPasswordConfirm'
                                value={newPasswordConfirm}
                                onChange={this.handlePasswordChange}
                            />
                        </FormGroup>
                        <span style={{ margin: '2px' }}>
                            <Button type='submit' bsStyle='primary'>Confirm</Button>
                        </span>
                    </Form>
                }

                <Modal show={showModal} onHide={this.handleModalClose} >
                    <Modal.Body>
                        <Alert bsStyle='success'>
                            {modalMessage}
                        </Alert>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleModalClose}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ForgotCredentials;